// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__M-FUL","spin":"loader_spin__u99fp","loaderWrapper":"loader_loaderWrapper__wuGgE","loaderHeight":"loader_loaderHeight__uz3Dv"};